// src/utils/statsUtils.js
import { baseUrl } from "../../../utils/userInfo";

export async function fetchDeviceStats(token) {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const from = Math.floor(now.getTime() / 1000);

  now.setHours(23, 59, 59, 999);
  const to = Math.floor(now.getTime() / 1000);

  const payload = {
    data: "U,I,P",
    statData: "MIN,MAX,AVG",
    phase: "CUM",
    from,
    to,
    token,
  };

  try {
    const response = await fetch(`${baseUrl}/api2-r/statistics`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    return {
      voltageStats: {
        MIN: parseFloat(result.data?.U?.CUM?.MIN),
        AVG: parseFloat(result.data?.U?.CUM?.AVG),
        MAX: parseFloat(result.data?.U?.CUM?.MAX),
      },
      currentStats: {
        MIN: parseFloat(result.data?.I?.CUM?.MIN),
        AVG: parseFloat(result.data?.I?.CUM?.AVG),
        MAX: parseFloat(result.data?.I?.CUM?.MAX),
      },
      powerStats: {
        MIN: parseFloat(result.data?.P?.CUM?.MIN),
        AVG: parseFloat(result.data?.P?.CUM?.AVG),
        MAX: parseFloat(result.data?.P?.CUM?.MAX),
      },
    };
  } catch (error) {
    //console.error("❌ Error in fetchDeviceStats:", error);
    return {
      voltageStats: null,
      currentStats: null,
      powerStats: null,
    };
  }
}
